import { Overrides } from "@material-ui/core/styles/overrides";
import { muiAvatarOverrides } from "./Avatar";

const overrides: Overrides = {
  // @ts-ignore
  MuiAvatar: { ...muiAvatarOverrides },
};

export default overrides;
